import { createSelector } from '@reduxjs/toolkit';

import { selectSpecialtyTypes } from 'shared/selectors/jsonQuery';

import { selectSpecialtyTypesLabel } from './selectSpecialtyTypesLabel';
import { selectSpecialtyTypesOptions } from './selectSpecialtyTypesOptions';

export const selectSpecialtyTypesFilter = createSelector(
  [selectSpecialtyTypes, selectSpecialtyTypesLabel, selectSpecialtyTypesOptions],
  (value, label, options) => ({
    label,
    value: value ?? [],
    options,
  }),
);
